export default __webpack_public_path__ + "8b8831d3df39e834327833c19ea140cf.ttf";